<template>
   <router-link to="/cart" class="header-cart-link group relative inline-flex shrink-0 items-center justify-center" aria-label="Перейти в корзину">
   <PhShoppingCart :size="22" :weight="'regular'" :color="iconColor" class="mobile-icon shrink-0 transition-colors group-hover:!text-brand" :class="{ '!text-brand': isCartRoute }" aria-hidden="true" />

        <span
            v-if="cart.cartCount > 0"
            class="absolute -right-1.5 -top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-brand px-0.5 text-[9px] font-bold leading-none text-white shadow-sm"
        >{{ formattedCount }}</span>
   </router-link>
</template>

<script setup>
import { useCart } from '@/store/useCart'
import { useRoute } from 'vue-router'
import { onBeforeMount, computed } from 'vue'
import { PhShoppingCart } from '@phosphor-icons/vue'
import { formatCompactNumber } from '@/utils/numberUtils'

const cart = useCart();
const route = useRoute();

onBeforeMount(() => {
    cart.refreshCart();
})

const isCartRoute = computed(() => {
    return route.name === 'cart'
})

const iconColor = computed(() => {
    // Используем CSS переменные вместо hex-кодов
    const root = getComputedStyle(document.documentElement)
    return isCartRoute.value 
        ? root.getPropertyValue('--icon-primary').trim() || '#DC2626'
        : root.getPropertyValue('--icon-default').trim() || '#475569'
})

const formattedCount = computed(() => {
    return formatCompactNumber(cart.cartCount)
})
</script>